export const WEBURLEGALES = process.env.REACT_APP_API_WEB
